<template>
    <div>
      <Header></Header>
      <div class="box">
      <div class="head-a">
        <img src="static/images/logo2.png" alt="">
      </div>
      <div class="content">
        <div>
          <h1>联系客服</h1>
          <div style="text-align:center;">
            <img style="width:300px;height:300px;" src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/qrcode.png" alt="">
          </div>
        </div>
        <h1>
          关于本站
        </h1>
        <p class="info">
          本站致力于数据处理的基础工具，关于数据的采集，基础计算等内容。
          为你的数据处理提供方便，提升你数据的处理的效率，希望大家多关注本站。
        </p>
      </div>
      </div>
    </div>
</template>
<script>
import Header from './header'

export default {
  components: {
    Header
  },

  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
@media (max-width: 768px){
  .box {
    width: 90vw !important;
  }
  .tx-box {
    margin: 0 !important;
  }
  .tb-box {
    margin: 40px 0 !important;
  }

}
.box {
  margin: 60px auto;
  width: 60vw;
}
.head-a {
  background: #398dee;
  border-radius: 7px;
  padding: 20px;
}
.content {
  text-align: left;
  margin: 20px 0;
}
.info {
  font-size: 18px;
  line-height: 34px;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue